"use client";
import { useRouter } from "@/lib/useRouter";

export const useCurrentPath = () => {
  const router = useRouter();
  return router.pathname;
};
